module.exports = __webpack_public_path__ + "img/logo_muten.21910c61.svg";